import { FOOTER_CONSTANTS } from './footer-constants';
var FooterFoundation = /** @class */ (function () {
    function FooterFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._layout = FOOTER_CONSTANTS.strings.DEFAULT_LAYOUT;
        this._layoutBreakpoint = FOOTER_CONSTANTS.numbers.LAYOUT_BREAKPOINT;
        this._mediaChangeHandler = function (evt) { return _this._onMediaChange(evt); };
    }
    FooterFoundation.prototype.initialize = function () {
        this._applyLayout();
        this._adapter.setRole();
    };
    FooterFoundation.prototype.disconnect = function () {
        this._removeMediaQuery();
    };
    Object.defineProperty(FooterFoundation.prototype, "layout", {
        /** Gets/sets the layout mode */
        get: function () {
            return this._layout;
        },
        set: function (value) {
            if (this._layout !== value) {
                this._layout = value;
                this._applyLayout();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterFoundation.prototype, "layoutBreakpoint", {
        /** Gets/sets the breakpoint for automatic layout switching */
        get: function () {
            return this._layoutBreakpoint;
        },
        set: function (value) {
            if (this._layoutBreakpoint !== value) {
                this._layoutBreakpoint = value;
                this._applyLayoutBreakpoint();
            }
        },
        enumerable: true,
        configurable: true
    });
    FooterFoundation.prototype._applyLayout = function () {
        if (this._layout === 'auto') {
            this._setMediaQuery();
            this._adapter.setHostAttribute(FOOTER_CONSTANTS.attributes.LAYOUT, 'auto');
            return;
        }
        this._removeMediaQuery();
        if (this._layout === 'alternative') {
            this._adapter.setHostAttribute(FOOTER_CONSTANTS.attributes.LAYOUT, 'alternative');
            this._adapter.setAlternativeLayout(true);
        }
        else if (this._layout === 'standard') {
            this._adapter.setHostAttribute(FOOTER_CONSTANTS.attributes.LAYOUT, 'standard');
            this._adapter.setAlternativeLayout(false);
        }
    };
    FooterFoundation.prototype._applyLayoutBreakpoint = function () {
        this._adapter.setHostAttribute(FOOTER_CONSTANTS.attributes.LAYOUT_BREAKPOINT, this._layoutBreakpoint.toString());
        if (this._layout === 'auto') {
            this._removeMediaQuery();
            this._setMediaQuery();
        }
    };
    FooterFoundation.prototype._setMediaQuery = function () {
        this._mediaQuery = window.matchMedia("(max-width: " + this._layoutBreakpoint + "px)");
        this._mediaQuery.addEventListener('change', this._mediaChangeHandler);
        this._onMediaChange(this._mediaQuery);
    };
    FooterFoundation.prototype._removeMediaQuery = function () {
        if (this._mediaQuery) {
            this._mediaQuery.removeEventListener('change', this._mediaChangeHandler);
        }
    };
    FooterFoundation.prototype._onMediaChange = function (evt) {
        this._adapter.setAlternativeLayout(evt.matches);
    };
    return FooterFoundation;
}());
export { FooterFoundation };
